import apiClient from './client'

export const trackingApi = {
  /**
   * 上报追踪数据 (URL参数, IP等)
   * @param {Object} data - 追踪数据
   * @returns {Promise}
   */
  collect(data) {
    return apiClient.post('tracking/collect', data, {
      skipLoading: true, // 后台静默上报
      skipErrorHandler: true // 失败不报错
    })
  }
}
